// Notification center (bell + dropdown) for the admin SPA.
// Backend: /api/v1/notifications/me (+ /unread-count, /{id}/read,
// /me/read-all). Identical contract across all three SPAs.
import { apiClient } from "./client";


export interface NotificationItem {
  id: number;
  type: string;
  title: string;
  message: string;
  is_read: boolean;
  created_at: string;
  user_id: number;
}


export const NotificationsApi = {
  list: (params?: { unread_only?: boolean }) =>
    apiClient.get<NotificationItem[]>("/notifications/me", { params }),
  unreadCount: () =>
    apiClient.get<{ count: number }>("/notifications/me/unread-count"),
  markRead: (id: number) =>
    apiClient.put<{ message: string }>(`/notifications/${id}/read`),
  markAllRead: () =>
    apiClient.put<{ message: string }>("/notifications/me/read-all"),
};
